import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthEventsService {
  private readonly logoutSubject = new ReplaySubject<void>(1);

  get onLogout$(): Observable<void> {
    return this.logoutSubject.asObservable();
  }

  requestLogout(): void {
    this.logoutSubject.next();
  }
}
